import { useState, useEffect } from 'react';
import adminService from '../services/adminService';
import { useCurrentUser } from './useCurrentUser';

const useAdminStatus = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const currentUser = useCurrentUser();

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        setLoading(true);
        const adminStatus = await adminService.isCurrentUserAdmin(currentUser.email);
        setIsAdmin(adminStatus);
      } catch (err) {
        console.error('Error checking admin status:', err);
        setError(err.message);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    if (currentUser.email) {
      checkAdminStatus();
    } else {
      setLoading(false);
      setIsAdmin(false);
    }
  }, [currentUser.email]);

  return { isAdmin, loading, error };
};

export default useAdminStatus; 